angular.module('zc.zenclerkS')
  .component('zcsAgencyHome', {
    templateUrl: '/templates/zenclerk_s/agencies/home/agency_home.html',
    bindings: {
      agency: '<'
    },
    controller: ZcsAgencyHomeController
  });

ZcsAgencyHomeController.$inject = ['AgencyProject', 'AgencyUser'];
function ZcsAgencyHomeController(AgencyProject, AgencyUser) {
  const vm = this;

  vm.projects = [];
  vm.showTestProjects = false;
  vm.projectsFetched = false;

  // functions
  vm.updateProjects = updateProjects;

  vm.$onInit = () => {
    AgencyUser.all(vm.agency.name).then(users => {
      vm.users = users;
    });

    AgencyProject.all(vm.agency.name).then(projects => {
      vm.projectsFetched = true;

      projects = _.filter(projects, { product_line: 'zenclerk_s', is_demo: false, is_test: false });
      vm.installationFinishedProjects = _.filter(projects, d => d.started_campaigns.length > 0);
      vm.allProjects = projects;

      vm.lastProjects = _.chain(projects)
        .filter(d => moment().diff(moment(d.created_at), 'days') < 90)
        .sortBy(d => -new Date(d.created_at))
        .value();

      updateProjects();
    });
  };

  function updateProjects() {
    if(vm.showTestProjects) {
      vm.projects = vm.allProjects.slice(0);
    } else {
      vm.projects = _.reject(vm.allProjects, p => p.is_test);
    }
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/home/agency_home.component.js